export default function ReturnAssetIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15"
      height="15"
      x="0"
      y="0"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M288.502 32.502c-108.328 0-198.827 77.485-219.166 179.899l-42.482-53.107L0 180.784l68.769 85.961a17.212 17.212 0 0 0 13.427 6.447c2.596 0 5.226-.585 7.685-1.805l103.153-51.577-15.387-30.757-75.8 37.892c14.063-90.5 92.27-160.059 186.655-160.059 104.271 0 189.114 84.843 189.114 189.114s-84.843 189.114-189.114 189.114v34.384C411.735 479.498 512 379.233 512 256S411.735 32.502 288.502 32.502z"
          fill="currentColor"
          opacity="1"
          data-original="currentColor"
        ></path>
      </g>
    </svg>
  );
}
